<template>
  <div class="component_card component_card_select component_card_select_white">
    <div class=" redeem_form">
      <div class="component_card_select_title">
        <span
          class="text_m_blu"
        >{{$t('msg.select_partner')}}</span>
      </div>
      <div class="component_card_select_body ">

        <div
          class="component_card_select_button column"
          @click="selectPartner('stratum')"
        >
          <div class="partner_icon m5_t">
            <i v-html="iconSets.smartwallet_stm_icon"></i>
          </div>
          <div class="component_card_select_button_text m15_l">
            <div class="logo_text bt_orange">
              <img
                class="mw100"
                src="../../../../assets/images/withdraw_stm_button_1.svg"
              />
              <i v-html="iconSets.smartwallet_font"></i>
            </div>
            <p v-html="$t('msg.transfer_blu_stratum')" class="fs_small m5_t"></p>
          </div>
        </div>

        <div
          class="component_card_select_button column disabled_button"
        >
          <div class="partner_icon m5_t">
            <i v-html="iconSets.saw_icon"></i>
          </div>
          <div class="component_card_select_button_text m15_l">
            <div class="logo_text bt_orange_sw">
              <img
                class="mw100"
                src="../../../../assets/images/withdraw_saw_button_stratum.svg"
              />
              <i v-html="iconSets.crypto_wallet_font"></i>
            </div>
            <p v-html="$t('msg.transfer_blu_stratum_withdraw_sw')" class="fs_small m5_t"></p>
          </div>
        </div>

        <div
          class="component_card_select_button column disabled_button"
          @click="selectPartner('stratumx')"
        >
          <div class="partner_icon m5_t">
            <i v-html="iconSets.exchange_sx_icon"></i>
          </div>
          <div class="component_card_select_button_text m15_l">
            <div class="logo_text bt_blue">
              <img
                class="mw100"
                src="../../../../assets/images/withdraw_stmx_button_1.svg"
              />
              <i v-html="iconSets.exchange_font"></i>
            </div>
            <p v-html="$t('msg.transfer_blu_stx')" class="fs_small m5_t"></p>
          </div>
        </div>

        

      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.checkAmount();
    this.getWithdrawFee();
  },
  mounted() {},
  data: () => ({
    selectedPartner: ""
  }),
  components: {},
  methods: {
    setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    selectPartner(partner) {
      this.selectedPartner = partner;
      this.callNextStep();
    },
    callNextStep() {
      this.$emit("callNext", this.selectedPartner);
    },

    async getWithdrawFee() {
      let resp = await this.$store.dispatch("getFees");
      let fees = resp.data;

      let arrayFee = [];

      for (let i in fees) {
        if (fees[i].type == "withdraw") {
          arrayFee.push(fees[i].fee);
        }
      }
      this.feeWithdraw = arrayFee[arrayFee.length - 1];
    },

    xemToBlu(amount) {
      let xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },

    setMinAmount() {
      let bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },

    checkAmount() {
      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },

    validateAmount() {
      this.bluAmountValid = false;
      let indices = [];
      let amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },

    isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },

    getUnlockedBalance() {
      if (this.bluAccount) {
        let totalBalance = this.bluAccount.balance;
        let lockedBalace = this.bluAccount.locked;
        let unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },

    validateAdress(address) {
      if (
        (address.length > 10 && address.charAt(0) === "N") ||
        address.charAt(0) === "T"
      ) {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },

    modifyBluAmount(modifier) {
      if (
        this.bluAmount == false ||
        this.bluAmount < this.minBlue ||
        this.bluAmount == ""
      ) {
        this.bluAmount = this.minBlue;
      } else {
        let vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          let result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },

    roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },

    isNumber() {
      let evt = window.event;
      var charCode = evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    switchMode() {
      this.$emit("switchMode");
    }
  },
  computed: {
    ...mapGetters([
      "btcValue",
      "bluValue",
      "bluAccount",
      "ethValue",
      "xemValue"
    ])
  },
  watch: {
    bluAmount: function() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function() {
      this.setMinAmount();
    }
  }
};
</script>
<style scoped>
.icon-container {
  background: white;
  width: 70px;
  border-style: solid;
  border-width: 1px 0px 1px 1px;
  border-color: #e3d4d4;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/private/services/withdraw_steps/WithdrawStep02.vue